import React from 'react';

import { Box, BoxProps, IconButton } from '@mui/material';

import { COLOR_BORDER } from '~/components/App/theme';
import { ReloadIcon } from '~/components/icons';

interface IImageRetry extends Pick<BoxProps, 'sx' | 'children'> {
  width?: number;
  height?: number;
  retry: () => void;
}

export const ImageRetry: React.FC<IImageRetry> = (props) => {
  const { sx, retry, width = 38, height = 44, children, ...others } = props;
  return (
    <Box
      sx={[{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: 1,
        background: COLOR_BORDER,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...others}
    >
      <IconButton onClick={retry} sx={{ p: 0 }}>
        <ReloadIcon sx={{ width, height, color: ({ palette }) => palette.secondary.main }} />
      </IconButton>
      {children}
    </Box>
  );
}
